import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-feedback-item',
  templateUrl: './form-feedback-item.component.html',
  styleUrls: ['./form-feedback-item.component.scss'],
})
/**
 * A feedback for a form
 */
export class FormFeedbackItemComponent {
  private _fail = false;

  /**
   * if this feedback is failing
   */
  @Input()
  get fail() {
    return this._fail;
  }

  /**
   * Use fail as a directive
   * @param {any} value
   */
  set fail(value: any) {
    this._fail = coerceBooleanProperty(value);
  }
}
